import React from "react";
import { useTranslation } from "react-i18next";
import img1 from "../../Assets/Images/Space/story-img-01.png";
import img2 from "../../Assets/Images/Space/story-img-02.png";
import img3 from "../../Assets/Images/Space/story-img-03.png";
import img4 from "../../Assets/Images/Space/story-img-04.png";
import img5 from "../../Assets/Images/Space/story-img-05.png";
import img6 from "../../Assets/Images/Space/story-img-06.png";
import img7 from "../../Assets/Images/Space/story-img-07.png";
import img8 from "../../Assets/Images/Space/story-img-08.png";
import img9 from "../../Assets/Images/Space/story-img-01.png";

import "./style.scss";

const dataGallery = (t: any) => [
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img1,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img2,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img3,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    img: img4,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img5,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza"),
    darkStatus: true
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img6,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza"),
    darkStatus: true
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.one_ilwall"),
    img: img7,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza"),
    darkStatus: true
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    img: img8,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    img: img9,
    titleHover: t("projects.ddp_plaza"),
    detailHover: t("details.ddp_plaza")
  }
];

function Space() {
  const { t } = useTranslation();
  const gallery = dataGallery(t);
  return (
    <div className="space-page">
      <div className="space-title">
        <h2>{t("menu.spaceDesign")}</h2>
      </div>

      <div className="space-list">
        {gallery.map((item, index) => (
          <div key={index} className="space-list-item">
            <div className="item-content">
              <div className="item-img">
                <img src={item.img} alt="" />

                <div className="content-img">
                  <div className="title">{item.titleHover}</div>
                  <p className="detail">{item.detailHover}</p>
                </div>

                <div className="list-status">
                  <div
                    className={`button-status ${
                      item.darkStatus ? "darkStatus" : ""
                    }`}
                  >
                    #{item.status}
                  </div>
                  <div className="button-status">{item.quantity}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Space;
